import { render, staticRenderFns } from "./PageGoodsList.vue?vue&type=template&id=421a6051&scoped=true"
import script from "./PageGoodsList.vue?vue&type=script&lang=js"
export * from "./PageGoodsList.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsList.vue?vue&type=style&index=0&id=421a6051&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a6051",
  null
  
)

export default component.exports